export class UomsDto{
    uomId?: number;
    uomName:string;
    uomType:string;
    createdUser:string;
    isActive:boolean;
    /**
     * 
     * @param uomId 
     * @param uomName
     * @param uomType
     * @param createdUser
     * @param isActive 
     * 
     */
    constructor(uomId:number,uomName:string,uomType:string,createdUser:string,isActive:boolean){
        this.uomId = uomId;
        this.uomName = uomName;
        this.uomType = uomType;
        this.createdUser = createdUser;
        this.isActive = isActive;
    }
}